import React from "react";
import ConfirmDialog from "../../../../../components/common/ConfirmDialog";
import { CardMetricKey } from "../AgencyDashboardTabs";
import { HiCheckCircle } from "react-icons/hi";
import { RiCloseCircleFill, RiSubtractLine } from "react-icons/ri";
import { toLakhs } from "../../../../../components/functions/utilities";
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons";
import moment from "moment";
import styles from "./TargetHistoryModal.module.scss";
import getclientNameById from "../../../../../components/functions/getclientNameById";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { IoMdClose } from "react-icons/io";

function TargetHistoryModal({
  targetHistoryData,
  isTargetHistoryModalOpen,
  setIsTargetHistoryModalOpen,
  setIsCloseButtonClicked,
  isTargetHistoryByClientId = false,
  isOpenedByDashboard = false,
  clientName = "",
}: any) {
  const clientsObj = useSelector(
    (s: RootState) => s.agencyConfig.clientsObj ?? {}
  );
  const getTargetPerc = (metricObj, isSales = false) => {
    if (!metricObj || !metricObj?.target || !metricObj?.targetMet) {
      return null;
    } else {
      return `${(
        (metricObj.value / metricObj.target) * 100 +
        (!isSales ? 100 : 0)
      ).toLocaleString("en-IN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
    }
  };

  if (!targetHistoryData || Object.keys(targetHistoryData).length === 0) {
    if (!isTargetHistoryByClientId) {
      return (
        <ConfirmDialog
          size={"md"}
          visible={isTargetHistoryModalOpen}
          backdropClassName="customTransparentBackdrop"
          showButton={false}
          showCloseBtn={false}
        >
          <div className={styles.noDataMainContainer}>
            <div className={styles.noDataContainer}>
              <div className={styles.upperTextContainer}>
                <div className={styles.noteEmoji}>📝</div>
                <div className={styles.title}>{`Make ${moment().format(
                  "MMMM"
                )} Count!`}</div>
                <div className={styles.noDataDescription}>
                  <div>{`You didn’t set brand targets in ${moment()
                    .subtract(1, "month")
                    .format("MMMM")}`}</div>

                  <div>Set them now to keep your brands on track.</div>
                </div>
              </div>
              <div className={styles.lowerButtonContainer}>
                <MeritoButton
                  type="secondary-2"
                  size="lg"
                  btnText="Maybe Later"
                  isRounded={true}
                  onClick={() => {
                    setIsTargetHistoryModalOpen(false);
                    setIsCloseButtonClicked(true)
                  }}
                />
                <MeritoButton
                  type="primary-1"
                  size="lg"
                  btnText={`Set ${moment().format("MMMM")} Targets`}
                  isRounded={true}
                  onClick={() => {
                    setIsTargetHistoryModalOpen(false);
                    setIsCloseButtonClicked(true)
                  }}
                />
              </div>
            </div>
          </div>
        </ConfirmDialog>
      );
    } else {
      return (
        <ConfirmDialog
          size={"lg"}
          visible={isTargetHistoryModalOpen}
          backdropClassName="customTransparentBackdrop"
          showButton={false}
          showCloseBtn={false}
        >
          <div className={styles.targetHistoryModalHeaderTwo}>
            <div className={styles.modalHeading}>
              <div>
                {isOpenedByDashboard && (
                  <div className={styles.clientName}>{clientName}</div>
                )}
                <div className={styles.targetHistoryText}>Target History</div>
              </div>

              <MeritoButton
                type="tertiary"
                size="md"
                icon={<IoMdClose />}
                onClick={() => setIsTargetHistoryModalOpen(false)}
                onlyIcon={true}
              />
            </div>
            <div className={styles.noDataAwailableText}>
              Target history unavailable.
            </div>
          </div>
        </ConfirmDialog>
      );
    }
  }

  console.log("targetHistoryData", targetHistoryData);
  return (
    <div>
      <ConfirmDialog
        size={"lg"}
        visible={isTargetHistoryModalOpen}
        backdropClassName="customTransparentBackdrop"
        showButton={false}
        showCloseBtn={false}
      >
        <div className={styles.targetHistoryModalContainer}>
          {!isTargetHistoryByClientId && (
            <div className={styles.targetHistoryModalHeader}>
              <div className={styles.celebrationIcon}>🎉</div>
              <div className={`${styles.modalHeading} ${styles.justifyCenter}`}>
                Bullseye or Just Missed?
              </div>
              <div className={styles.modalDescription}>
                {`Here’s how your brands performed against ${moment()
                  .subtract(1, "month")
                  .format("MMMM")}’s targets
                        -`}
              </div>
            </div>
          )}
          {isTargetHistoryByClientId && (
            <div className={styles.targetHistoryModalHeader}>
              <div className={styles.modalHeading}>
                <div>
                  {isOpenedByDashboard && (
                    <div className={styles.clientName}>{clientName}</div>
                  )}
                  <div className={styles.targetHistoryText}>Target History</div>
                </div>

                <MeritoButton
                  type="tertiary"
                  size="md"
                  onlyIcon={true}
                  icon={<IoMdClose />}
                  onClick={() => setIsTargetHistoryModalOpen(false)}
                />
              </div>
            </div>
          )}

          <div className={styles.modalTableOuter}>
            <table className={styles.modalTable}>
              <thead className={styles.modalTableHead}>
                <tr>
                  <th>
                    <div>{isTargetHistoryByClientId ? "Month" : "Brand"}</div>
                  </th>
                  <th>
                    <div>
                      <div>Sales</div>
                      <div>(₹ in lakhs)</div>
                    </div>
                  </th>
                  <th>
                    <div>Target Hit</div>
                  </th>
                  <th>
                    <div>
                      <div>Ad Spends</div>
                      <div>(₹ in lakhs)</div>
                    </div>
                  </th>
                  <th>
                    <div>Within Budget</div>
                  </th>
                </tr>
              </thead>

              <tbody>
                {targetHistoryData &&
                  Object.entries(targetHistoryData).map(
                    ([clientId, metrics]) => (
                      <tr key={clientId} className={styles.modalTableRow}>
                        <td>
                          <div>
                            {isTargetHistoryByClientId
                              ? moment(clientId, "DD-MM-YYYY").format(
                                "MMMM YYYY"
                              )
                              : getclientNameById(clientsObj, Number(clientId))}
                          </div>
                        </td>

                        <td>
                          <div>
                            <div>
                              {toLakhs(metrics[CardMetricKey.Sales]?.value)}
                              <span className={styles.modalTargetVal}>
                                {metrics[CardMetricKey.Sales]?.target !== null
                                  ? ` / ${toLakhs(
                                    metrics[
                                      CardMetricKey.Sales
                                    ]?.target.toFixed(1)
                                  )}`
                                  : ""}{" "}
                              </span>
                            </div>
                            <div className={styles.targetPerc}>
                              {getTargetPerc(
                                metrics[CardMetricKey.Sales],
                                true
                              ) ? (
                                `${getTargetPerc(
                                  metrics[CardMetricKey.Sales],
                                  true
                                )} %`
                              ) : metrics[CardMetricKey.Sales]?.target !==
                                null ? (
                                ""
                              ) : (
                                <span className={styles.noTargetText}>
                                  No target
                                </span>
                              )}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            {metrics[CardMetricKey.Sales]?.targetMet ? (
                              <HiCheckCircle className={styles.checkCircle} />
                            ) : metrics[CardMetricKey.Sales]?.targetMet ===
                              0 ? (
                              <RiCloseCircleFill
                                className={styles.closeCircle}
                              />
                            ) : (
                              <RiSubtractLine className={styles.subtractLine} />
                            )}
                          </div>
                        </td>
                        <td>
                          <div>
                            <div>
                              {toLakhs(metrics[CardMetricKey.AdSpends]?.value)}
                              <span className={styles.modalTargetVal}>
                                {metrics[CardMetricKey.AdSpends]?.target !==
                                  null
                                  ? ` / ${toLakhs(
                                    metrics[CardMetricKey.AdSpends]?.target
                                  )}`
                                  : ""}{" "}
                              </span>
                            </div>
                            <div className={styles.targetPerc}>
                              {getTargetPerc(
                                metrics[CardMetricKey.AdSpends]
                              ) ? (
                                `${getTargetPerc(
                                  metrics[CardMetricKey.AdSpends]
                                )} %`
                              ) : metrics[CardMetricKey.AdSpends]?.target !==
                                null ? (
                                ""
                              ) : (
                                <span className={styles.noTargetText}>
                                  No budget
                                </span>
                              )}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            {metrics[CardMetricKey.AdSpends]?.targetMet ? (
                              <HiCheckCircle className={styles.checkCircle} />
                            ) : metrics[CardMetricKey.AdSpends]?.targetMet ===
                              0 ? (
                              <RiCloseCircleFill
                                className={styles.closeCircle}
                              />
                            ) : (
                              <RiSubtractLine className={styles.subtractLine} />
                            )}
                          </div>
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>
          {!isTargetHistoryByClientId && (
            <div className={styles.modalFooter}>
              <div>
                <MeritoButton
                  type="secondary-2"
                  size="lg"
                  btnText={"Close"}
                  isRounded={true}
                  onClick={() => {
                    setIsTargetHistoryModalOpen(false);
                    setIsCloseButtonClicked(true);
                  }}
                />
              </div>
              <div>
                <MeritoButton
                  type="primary-1"
                  size="lg"
                  btnText={`Let’s Plan ${moment().format("MMMM")}`}
                  isRounded={true}
                  onClick={() => {
                    setIsTargetHistoryModalOpen(false);
                    setIsCloseButtonClicked(true);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </ConfirmDialog>
    </div>
  );
}

export default TargetHistoryModal;
